import {SpimValueModel} from "Core/Controls/Grid/Models/GridDataModel/GridCellValueModel";

export abstract class SpimValueViewModel {
    protected constructor(protected recordId: number) {
    }

    abstract GetTemplate(): any;
    abstract GetValue(): SpimValueModel;
}